var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.LI=require("moment");module.exports=$CLJS.LI;